import React, { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SnippetService from '../Services/SnippetService';
import AuthorSnippet from './Snippets/AuthorSnippet';
import CodeSnippet from './Snippets/CodeSnippet';
export default function EditSnippet(props) {
	let { id } = useParams();
	const [ snippet, setSnippet ] = useState(null);
	const [ snippetType, setSnippetType ] = useState(null);

	useEffect(() => {
		id = id.replace('___SNIPPET___', '').replace('___END___', '');

		SnippetService.getSnippet(
			decodeURIComponent(id).split('#')[0].trim(),
			decodeURIComponent(id).split('#')[1].trim()
		).then((a) => {
			setSnippet(a);
			setSnippetType(decodeURIComponent(id).split('#')[0].trim());
		});
	}, []);

	return (
		<Fragment>
			{snippet && snippetType === 'AuthorSnippet' && <AuthorSnippet type="update" iv={snippet} />}
			{snippet && snippetType === 'CodeSnippet' && <CodeSnippet type="update" iv={snippet} />}
		</Fragment>
	);
}
